<template>
  <div id="app">
    <div class="main">
      <div class="paly_game_box"
        v-if="$route.path == '/h5Game' || $route.path == '/cloudGaming' || $route.path == '/cloudGaming2'">
        <router-view />
      </div>
      <div class="main_box" v-else>
        <!-- 左边栏 -->
        <nav-bar-left></nav-bar-left>
        <!-- 中间内容 -->
        <div class="content">
          <div class="content_center">
            <!-- to搜索栏---组件 -->
            <search v-if="$route.path != '/gameDetail'"></search>
            <!-- 游戏区 -->
            <div class="view show_bar">
              <keep-alive :include="cachedComponents">
                <router-view />
              </keep-alive>
            </div>
          </div>
        </div>
        <!-- 右边游戏栏 -->
        <right-content></right-content>
        <!-- login -->
        <login :login_show="login_show"></login>
        <!-- 下载 -->
        <down-load :down_show="false"></down-load>
        <!-- 弹窗提示 -->
        <server-popup :popup_json="popup_json"></server-popup>
        <!-- 弹窗提示 -->
        <server-date :server_date_json="server_date_json"></server-date>
        <!-- 二维码 -->
        <code-popup
          :code_show.sync="code_show"
          v-bind="codePopupConfig"
          @close="handleCodePopupClose"
        ></code-popup>
        <div class="serve_box">
          <div class="serve_item" @click="handelServer">
            <img src="@/assets/image/lianxi_kefu_icon.png" alt="">
          </div>
          <!-- <div class="serve_item" @click="handelCode">
            <img src="@/assets/image/yin.gif" alt="">
          </div> -->
        </div>
      </div>
      <!-- 弹窗 -->
      <subscribe-popup :popup=popup1 :title='title' :content="content" :closeIcon='1' :isMask='false'
        @close="handleClose">
        <template v-slot:constent>
          <div class="text" v-if="popup_type == 3">
            <p>排队结束，是否进入云游戏？</p>
          </div>
          <div class="Vuefoot" v-if="popup_type == 3">
            <div class="count" @click="destroyResource(true)">
              否（{{ timestamp }} s）
            </div>
            <div @click="correct">是</div>
          </div>
          <div class="text" v-if="popup_type == 1">
            <p>因为排到您后长时间没有进入游戏，</p>
            <p>您的排队失败了，请重新启动云游戏。</p>
          </div>
          <div class="text" v-if="popup_type == 2">
            <p>因为异常情况导致您排队失败，</p>
            <p>请重新启动云游戏。</p>
          </div>
          <div class="Vuefoot" v-if="popup_type == 1 || popup_type == 2">
            <p class="know" @click="handleClose">我知道了</p>
          </div>
          <!-- h5弹窗--提示下载盒子 -->
          <div class="Tips_down" v-if="popup_type == 4">
            <img src="@/assets/image/logo_es.png" alt="">
            <p v-if="ilk == 20 || ilk == 21">当前50游戏APP版本暂不支持{{ Tips_down }}功能，点击下载最新版本50游戏APP即可完成{{ Tips_down }}</p>
            <p v-else>网页版暂时不支持{{ Tips_down }}功能，点击下载50游戏APP，在APP内完成{{ Tips_down }}。</p>
            <div class="Vuefoot">
              <div @click="handleClose">取消</div>
              <a @click="handleClose2" :href="box_link.box_link">安装50游戏</a>
            </div>
          </div>
        </template>
      </subscribe-popup>
    </div>
  </div>
</template>
<script>
import Search from '@/components/Search.vue'
import RightContent from '@/components/RightContent.vue'
import NavBarLeft from '@/components/NavBarLeft.vue'
import Login from '@/components/Login.vue'
import DownLoad from '@/components/DownLoad.vue'
import serverPopup from '@/components/serverPopup.vue'
import serverDate from '@/components/serverDate.vue'
import codePopup from '@/components/codePopup.vue'
import Bus from '@/util/Bus'
// import YSF from '@neysf/qiyu-web-sdk';
import { mapMutations, mapState } from "vuex";
import router from './router'
import MqttClient from '@/plugs/mqtt.js'
import CloudMqtt from '@/plugs/mqtt.js' // 云游戏
import 'vant/lib/notice-bar/style'
import subscribePopup from "@/components/subscribePopup/index.vue";
import { postData } from '@/api/api.js'

export default {
  name: 'App',
  components: {
    Search,
    RightContent,
    NavBarLeft,
    Login,
    DownLoad,
    serverPopup,
    serverDate,
    subscribePopup,
    codePopup
  },
  data() {
    return {
      ysfUrl: '',
      showMore: false,
      login_show: false,
      server_date_json: { show: false, type: '', id: '', text: '' },
      popup_json: { show: false, type: '', id: '', text: '' },
      cachedComponents: [],  // 存储需要缓存的组件名称
      //mqtt
      mqttClient: new MqttClient(),
      cloudMqtt: new CloudMqtt(),
      countdown: 2,
      record_index: 0,
      instance: null,
      lempInterval: null,
      timeOut: 0,

      popup1: 0,
      title: '',
      popup_type: 0, // 3-排队结束 1-排队失败（长时间） 2-排队失败（异常） 4-h5弹窗  6-（SDK跳盒子）未登录 7-（SDK跳盒子）已登录账号不一致
      roundId: 0,
      cloudGid: 0,//云游戏 游戏gid
      timestamp: 0,//云游戏倒计时
      cloud_data: "",//云游戏链接
      // content1:'',
      package_name: '',//包名
      content: '',

      successVerifyJump: '',
      sendIsSuccessVerify: '',
      allow: 0,
      //二维码弹窗
      code_show: false,
      codePopupConfig: this.getDefaultCodePopupConfig()
    }
  },
  computed: {
    ...mapState(["uid", "requestParams", "platform"]),
  },
  created() {
    this.handleMobileRedirect();
  },
  mounted() {
    window.cloudMqtt = this.cloudMqtt //mq
    window.cloudToMqtt = this.cloudToMqtt
    if (window.localStorage.getItem("access_token")) {
      this.cloudToMqtt();
      // this.connectToMqtt();
    }
    // 链接mq
    Bus.$on("LinkMqtt", () => {
      console.log("LinkMqtt");
      // this.connectToMqtt();
      this.cloudToMqtt();
    });
    // 链接mq
    Bus.$on("ChangePassword", () => {
      this.change_password = true;
    });
    if (this.uid) {
      this.getCustomerConfig((data) => {
      });
    }
    // 登录弹窗
    Bus.$on("loginShow", (isShow) => {
      this.login_show = isShow
    });
    Bus.$on("serverPopopShow", (data) => {
      this.popup_json = data ? data : {}
    });
    Bus.$on("serverDateShow", (data) => {
      this.server_date_json = data ? data : {}
    });
    Bus.$on("codePopopShow", (data = false) => {
      if (data && typeof data === 'object') {
        const { show = true, ...config } = data
        this.openCodePopup(config, show)
      } else {
        this.codePopupConfig = this.getDefaultCodePopupConfig()
        this.code_show = data
      }
    });
  },
  methods: {
    ...mapMutations(['handelPhoneIp']),
    //判断是否跳转手机端
    handleMobileRedirect() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent);
      const isProduction = process.env.NODE_ENV === 'production';
      if (isMobile) {
        if (isProduction) {
          window.location.href = 'https://ybox.50pk.com/storage/box/dist/#/index';
        } else {
          window.location.href = 'http://sbox.50pk.com/storage/box/dist/#/index';
        }
      }
    },
    // //客服用户信息获取
    async getCustomerConfig(cb) {
      const params = {
        access_token: window.localStorage.getItem("access_token"),
        uid: this.uid,
        sub_uid: 0,
        gid: 0,
        lid: this.requestParams.lid,
        equipment_id: this.requestParams.equmentid,
        equipment_idfv: this.requestParams.equmentidfv,
        platform: this.platform,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      };
      try {
        const res = await postData(
          "/user/customer-service/config",
          params
        );
        if (res?.code === 0) {
          ysf('config', {
            uid: res.data.uid,
            name: res.data.name,
            data: res.data.data,
            authToken: res.data.login_token,
          });
          this.ysfUrl = ysf('url')
          cb && cb(res.data);
        } else if (res.code === -1001) {
          const flag = await this.refreshToken();
          if (flag) {
            this.getCustomerConfig();
            this.getUserInfo()
          } else {
            // this.toPage('/index');
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    getDefaultCodePopupConfig() {
      return {
        title: '请用微信/浏览器扫码进行体验',
        showNavTips: false,
        navTips: '(请前往移动端进行实名认证)',
        showTips: false,
        tipsPrefix: '扫码打开',
        tipsHighlight: '50手游APP',
        tipsSuffix: '进行游玩',
      }
    },
    openCodePopup(config = {}, show = true) {
      this.codePopupConfig = {
        ...this.getDefaultCodePopupConfig(),
        ...config,
      }
      this.code_show = show
    },
    handleCodePopupClose() {
      this.code_show = false
      this.codePopupConfig = this.getDefaultCodePopupConfig()
    },
    handelCode() {
      this.openCodePopup()
    },
    handelServer() {
      console.log(this.ysfUrl, "this.ysfUrl")
      // return
      if (this.ysfUrl) {
        // 如果 url 是有效的，打开新页面
        console.log("获取到有uid的 URL");
        window.open(this.ysfUrl, '_blank');
      } else {
        console.log("没有获取到有uid的 URL");
        window.open(ysf('url'), '_blank');
      }
    },
    // 排队结束不进入云游戏
    async destroyResource(type = false) {
      if (type) {
        this.timeOut = 0;
      }
      window.localStorage.removeItem("CloudGamePlay");
      window.localStorage.removeItem("cloud_topic");
      this.cloudMqtt.unconnect()
      this.cloudToMqtt()
      const params = {
        access_token: window.localStorage.getItem('access_token'),
        equipment_idfv: this.requestParams.equmentidfv,
        equipment_id: this.requestParams.equmentid,
        uid: this.uid,
        roundId: this.roundId,
        gid: this.cloudGid,
        subchannelnum: this.requestParams.subchannelnum // 广告商分包id
      }
      try {
        const res = await postData('/box/cloud-game/destroy-resource/VeGame', params)
      } catch (err) {
        console.log(err)
      } finally {
        if (this.popup_type != 1 && this.popup_type != 2) {
          this.popup1 = 0;
        }
        this.eliminate()
        // console.log("排队结束不进入云游戏Vue",new Date().getTime(),this.popup_type,this.popup1);
      }
    },
    correct() {
      this.timeOut = 0;
      this.popup1 = 0;
      this.eliminate()
      // 排队结束进入云游戏
      setTimeout(() => {
        const sendMessage = (message) => {
          const timestamp = Date.now();
          localStorage.setItem('cloudGame', JSON.stringify({ message, timestamp }));
        };
        // 发送消息
        sendMessage(JSON.stringify(this.cloud_data));
      }, 1000);
      // } else {
      //$emit"CloudIframe", 改为url传值
      let dizhi = '';
      if (window.localStorage.getItem('cloud_landscape') == 1) {
        dizhi = `${dizhi}&url=${this.cloud_data.url}&tips=${this.cloud_data.tips}`
      } else if (this.cloud_game.landscape == 2) {
        dizhi = `${dizhi}&url=${this.cloud_data.url}&tips=${this.cloud_data.tips}`
      }
      console.log("dizhi:", dizhi, window.localStorage.getItem('cloud_landscape'));
      window.open(dizhi)
      // }
    },
    // 清除云游戏排队计时器
    eliminate() {
      if (this.lempInterval) {
        clearInterval(this.lempInterval);
        this.lempInterval = null;
        this.timestamp = -100;
      }
    },
    // 云游戏mq
    cloudToMqtt() {
      let accessToken = window.localStorage.getItem('access_token');
      if (!accessToken && this.cloudMqtt.checkConnection()) return
      console.log("云游戏mq")
      let server = 0;
      let production = "test";
      if (process.env.NODE_ENV === 'development') {
        server = 0;
        production = "test"
      } else {
        server = 2;
        production = "production"
      }
      this.cloudMqtt.connect(this.uid, parseInt(this.requestParams.gid), server, accessToken, 2);

      if (window.localStorage.getItem('cloud_topic')) {
        this.cloudMqtt.subscribeTopics(window.localStorage.getItem('cloud_topic'))
      }

      this.cloudMqtt.getMessage((topic, message) => {
        console.log("云游戏mq", topic, message)
        if (message && JSON.parse(message).event == "CloudGamePlayQueueMessage") {
          let list = JSON.parse(message)
          console.log(123456, list);
          let sourceName = window.localStorage.getItem('sourceName')
          this.source = { 'from_page': sourceName, gid: list.handlerParams.data.gid }
          if (list.handlerParams.code == 1) {
            window.localStorage.setItem('CloudGamePlay', message);
            Bus.$emit('CloudGamePlay', 1);
            this.roundId = list.handlerParams.data.roundId;
            this.cloudGid = list.handlerParams.data.gid;

            // let obj={
            //   accessToken: window.localStorage.getItem('access_token'),
            //   equmentId: this.requestParams.equmentid,
            //   uid: (this.uid+""),
            //   roundId:this.roundId,
            //   gid:(this.cloudGid+""),
            // }
            // console.log("obj",obj);
            // if (window.WebViewJs && typeof window.WebViewJs.cloudGameParameterToDestory === "function") {
            //   window.WebViewJs.cloudGameParameterToDestory(obj.accessToken,obj.equmentId,obj.uid,obj.roundId,obj.gid);
            // }
          }
          if (list.handlerParams.code == 2) {
            Bus.$emit('CloudGamePlay', 2)
            this.cloudGid = list.handlerParams.data.gid;
            this.roundId = list.handlerParams.data.roundId;
            this.cloud_data = list.handlerParams.data;

            if (this.timestamp > 0) return

            let timestamp = new Date().getTime();//当前时间戳
            let handlerime = Math.floor((list.handlerParams.time * 1) / 10);//开始时间戳
            this.timeOut = handlerime + 60000 - timestamp + handlerime;//结束时间戳
            // console.log("555555",list.handlerParams.time,handlerime,timestamp,this.timeOut);
            this.timestamp = Math.floor((this.timeOut - timestamp) / 1000);// 结束时间/s

            if (this.timestamp > 0) {
              this.eliminate()
              this.lempInterval = setInterval(() => {
                timestamp = new Date().getTime();
                this.timestamp = Math.floor((this.timeOut - timestamp) / 1000);
                // console.log("倒计时:",this.timestamp,timestamp);
              }, 1000);
            } else {
              this.eliminate();
              this.finishVue()
            }
            setTimeout(() => {
              this.popup_type = 3
              this.popup1 = 5;
              this.title = "排队结束";
            }, 100);

          }
          if (list.handlerParams.code == 3) { //排队错误
            Bus.$emit('CloudGamePlay', 2)
            this.cloudGid = list.handlerParams.data.gid;
            this.roundId = list.handlerParams.data.roundId;
            this.destroyResource();
            this.title = "排队失败";
            this.popup_type = 2;
            this.popup1 = 5;
          }
        }
        if (message && JSON.parse(message).event == "CloudGameRunningMessage") {
          let list = JSON.parse(message)
          console.log(654321, list);
          if (list.handlerParams.code == 2) { //退出云游戏
            if (list.handlerParams.data.type == "otherGameReplace") { //原因
              // 替换Bus.emit('otherGameReplace'
              window.localStorage.setItem("otherGameReplace", true)
              // Bus.$emit("otherGameReplace")
            }
          }
        }
        // 处理接收的消息
        console.log('云游戏-收到来自', topic, '的信息', message.toString());
      });

    },
    replace(path, query = {}) {
      this.$router.replace({
        path: path,
        query: query
      })
    },
    toPage(path, query = {}) {
      this.$router.push({
        path: path,
        query: query
      })
    },
    // 用户信息获取
    async getUserInfo() {
      const params = {
        gid: 0,
        lid: this.requestParams.lid,
        equipment_id: this.requestParams.equmentid,
        equipment_idfv: this.requestParams.equmentidfv,
        platform: this.platform,
        access_token: window.localStorage.getItem("access_token"),
        uid: this.uid,
        sub_uid: 0,
        rest: {},
        apptype: "gamebox",
      };
      const res = await postData("/box-user/user-info", params);
      if (res?.code === 0) {
        window.localStorage.setItem("userInfo", JSON.stringify(res.data));
      } else if (res.code === -1001) {
        const flag = await this.refreshToken();
        if (flag) {
          this.getUserInfo();
        } else {
          this.toPage('/index');
        }
      }
    },
    // 获取网络ip
    async clientIp() {
      const res = await postData('/report/client-ip')
      if (res.code === 0) {
        this.handelPhoneIp(res.data.ip)
      }
    },
    // 刷新 token
    async refreshToken() {
      const params = {
        gid: this.requestParams.gid,
        lid: this.lid ? this.lid : this.requestParams.lid,
        equipment_id: this.requestParams.equmentid,
        equipment_idfv: this.requestParams.equmentidfv,
        platform: this.platform,
        refresh_token: window.localStorage.getItem('refresh_token'),
        uid: this.uid,
        sub_uid: 0,
        subchannelnum: this.requestParams.subchannelnum // 广告商分包id
      }
      const res = await postData(
        '/user/refresh-token',
        params
      )
      if (res?.code === 0) {
        window.localStorage.setItem(
          'access_token',
          res.data.access_token,
          res.data.expires_in
        )
        window.localStorage.setItem(
          'refresh_token',
          res.data.refresh_token,
          res.data.refresh_token_expires_in
        )
        window.sessionStorage.setItem('loginMes', true)
        return true
      } else {
        window.localStorage.removeItem('access_token')
        window.localStorage.removeItem('refresh_token')
        window.localStorage.removeItem('userInfo')
        window.localStorage.removeItem('loginMes')
        return false
      }
    },
    // 倒计时结束
    finishVue() {
      if (this.popup_type != 1) {
        this.popup1 = 0;
      }
      // console.log("倒计时结束:finishVue",new Date().getTime());
      this.destroyResource()
    },
    // 弹窗-取消
    handleClose() {
      this.popup1 = 0;
    },
  },
  watch: {
    timestamp(val) {
      if (val != -100 && val <= 0) {
        this.eliminate()
        this.finishVue()
      }
    },
    login_show(newVal) {
      if (!newVal) {
        // 通知当前中间路由组件刷新数据
        // 登陆后---todo---增加路由判断去刷新页面数据
        Bus.$emit("refresh-current-route");
      }
    },
    $route: {
      handler(to) {
        window.scrollTo(0, 0);
        // 获取当前路由对应的组件名
        const componentName = to.matched?.slice(-1)[0]?.components?.default?.name;
        if (!componentName) return;

        if (to.meta.keepAlive) {
          // 需要缓存，如果不在数组中则添加
          if (!this.cachedComponents.includes(componentName)) {
            this.cachedComponents.push(componentName);
          }
        } else {
          // 不需要缓存，如果存在则移除
          const index = this.cachedComponents.indexOf(componentName);
          if (index !== -1) {
            this.cachedComponents.splice(index, 1);
          }
        }
      },
      immediate: true
    }
  },
  // 监听路由变化，根据 meta.keepAlive 动态更新 cachedComponents

}
</script>
<style lang="less">
#app {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #ffffff;
}

.main {
  position: relative;
  background: #ffffff;

  .paly_game_box {
    width: 100%;
  }

  .main_box {
    display: flex;
    padding: 0 25px;
    margin: auto;
    box-sizing: border-box;

    // 中间内容区域
    .content {
      display: flex;

      .content_center {
        height: 100%;
        margin: 0 auto;
        overflow-wrap: break-word;

        .view {
          display: flex;
          justify-content: center;
          height: inherit;
        }

        .show_bar {
          height: calc(100% - 120px);
          padding-bottom: 30px;
        }
      }

    }
  }
}

// 中间内容区域适配
@media (min-width: 1544px) {
  .main_box>.content {
    flex: 1;
  }

  .main_box .content .content_center {
    width: 672px;
  }
}

@media (min-width: 1336px) and (max-width: 1544px) {
  .main_box>.content {
    flex: 1;
  }

  .main_box .content .content_center {
    width: 672px;
  }
}

@media (min-width: 1280px) and (max-width: 1336px) {
  .main_box>.content {
    flex: 0 0 672px;
  }

  .main_box .content .content_center {
    width: 672px;
  }
}

@media (min-width: 1144px) and (max-width: 1280px) {
  .main_box>.content {
    width: 672px;
  }

  .main_box .content .content_center {
    width: 672px;
  }
}

@media (min-width: 752px) and (max-width: 1144px) {
  .main_box>.content {
    flex: 1;
  }

  .main_box .content .content_center {
    width: 672px;
    margin: auto !important;
  }
}

@media (min-width: 0px) and (max-width: 752px) {
  .main_box>.content {
    flex: 1;
  }

  .main_box .content .content_center {
    width: 672px;
    margin: auto !important;
  }
}

// 左侧导航宽度适配
@media (min-width: 1544px) {
  .main_box {
    width: 1544px;
  }
}

.serve_box {
  position: fixed;
  right: 20px;
  bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999999;

  .serve_item {}
}
</style>
